import React, { memo } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const LabelIcon = ({ fill, ...rest }: SvgIconProps) => (
  <SvgIcon width={14} height={14} {...rest} viewBox="0 0 14 14">
    <path
      d="M0.726747 6.38667L6.72675 0.386667C6.96675 0.146667 7.30008 0 7.66675 0L12.3334 0C13.0667 0 13.6667 0.6 13.6667 1.33333V6C13.6667 6.36667 13.5201 6.7 13.2734 6.94667L7.27341 12.9467C7.03341 13.1867 6.70008 13.3333 6.33341 13.3333C5.96675 13.3333 5.63341 13.1867 5.39341 12.94L0.726747 8.27333C0.48008 8.03333 0.333413 7.7 0.333413 7.33333C0.333413 6.96667 0.486747 6.62667 0.726747 6.38667ZM11.3334 3.33333C11.8867 3.33333 12.3334 2.88667 12.3334 2.33333C12.3334 1.78 11.8867 1.33333 11.3334 1.33333C10.7801 1.33333 10.3334 1.78 10.3334 2.33333C10.3334 2.88667 10.7801 3.33333 11.3334 3.33333Z"
      fill={fill}
    />
  </SvgIcon>
);

export default memo(LabelIcon);
